import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { CampaignDetailsQueryParams } from '@/scopes/search/search/domain/campaign-details/types';
import { useSearchDependencies } from '@/scopes/search/search/pages/SearchPage/context';

export function useCampaignDetails(campaignId: string) {
  const { isLoading, isFetching, error, data } = useCampaignDetailsQuery(campaignId);

  return {
    isLoading,
    isFetching,
    error,
    campaignDetails: data,
  };
}

export function useCampaignDetailsQuery(campaignId: string) {
  const { campaignDetailsApiClient } = useSearchDependencies();
  const queryParams: CampaignDetailsQueryParams = { campaignId };

  return useQuery({
    queryKey: ['campaign-details', JSON.stringify(queryParams)],
    queryFn: () => campaignDetailsApiClient.getCampaignDetails(queryParams),
    placeholderData: keepPreviousData,
    staleTime: 60 * 60000, // Set the cache duration in milliseconds (1 hour in this example),
  });
}
